import type { CommandCategory } from './types';

/** Display order and labels for the command palette sections */
export const CATEGORY_ORDER: CommandCategory[] = [
  'Actions',
  'Insert Code',
  'Viewer',
  'Parameters',
  'Files',
  'Navigation',
];

export const CATEGORY_LABELS: Record<CommandCategory, string> = {
  Actions: 'Actions',
  'Insert Code': 'Insert Code',
  Viewer: 'Viewer',
  Parameters: 'Parameters',
  Files: 'Files',
  Navigation: 'Navigation',
};
